import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IRequest, IResponse } from "./company-dialog.model";
import { map, Observable } from "rxjs";
import { IResult } from "src/app/core/interfaces/result";
import { CommunicationConstants } from "src/app/core/constants/communication";

const API_MAIN = environment.security + environment.host + environment.version + environment.typeService;

@Injectable()
export class CompanyDialogService {

    private URL: string = API_MAIN + "company-api/get-all";

    constructor(private _http: HttpClient) { }

    getPaginated(request: IRequest): Observable<any> {

        return this._http
            .post<IResult<IResponse>>(this.URL, request)
            .pipe(
                map((res: IResult<IResponse>) => {
                    const [codigosCom, mensajesCom] = CommunicationConstants;
                    if (res === null) {
                        throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
                    }
                    return res.Data;
                })
            );
    }

}
